module.exports = "/images/unionpay.svg";